import { createStore } from 'vuex';

import auth from './auth';
import users from './users';
import products from './products';
import locations from './locations';
import settings from './settings';
import dashboard from './dashboard';
import labels from './labels';
import inventory from './inventory';
import suppliers from './suppliers';
import customers from './customers';
import reports from './reports';
import categories from './categories';


export default createStore({
  modules: {
    auth,
    users,
    products,
    locations,
    settings,
    dashboard,
    labels,
    inventory,
    suppliers,
    customers,
    reports,
    categories
  }
});